import React from "react";
import NotificationHistoryTableRow from "./NotificationHistoryTableRow";
import FilterHeader from "@/components/elements/global/FilterHeader";


const NotificationHistoryTable = ({
  filterOptions,
  setFilterOptions,
  notificationHistory,
  scrollTo,
  isLoading,
}: INotificationHistoryTable) => {
  return (
    <>
      <table
        className="notification-history-table"
        aria-label="Notification History Table"
      >
        <thead>
            <tr>
                <FilterHeader
                    columnNames={[
                        "Author",
                        "Type",
                        "Created",
                        "Sent",
                        "Status",
                        "Audience Reach",
                    ]}
                    setFilter={(filter) => {
                        setFilterOptions(filter);
                    }}
                    currentFilters={filterOptions}
                />
            </tr>
        </thead>
      </table>
      <div className="notification-history-table-wrapper table-wrapper narrow-scroll-bar">
        <table className="notification-history-table header-table row-container">
          <tbody>
            {notificationHistory.items.map((item, index) => (
              <NotificationHistoryTableRow
                key={item.id}
                author={item.author}
                type={item.type}
                created={item.dateCreated}
                sent={item.dateSent}
                status={item.status}
                reach={item.audienceReach}
                hasBgColor={index % 2 !== 1}
              />
            ))}
            {notificationHistory.totalItems >
              notificationHistory?.items.length && !isLoading && (
              <div className={`next-page-wrapper`} data-testid={'next-page-wrapper'} ref={scrollTo} />
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NotificationHistoryTable;
